<template>
  <div>
    <div v-if="!validToken" @click="dialogVisible = true">
      <slot />
    </div>

    <!-- 登录框 -->
    <el-dialog v-if="dialogVisible" class="login-pop" :visible.sync="dialogVisible" :before-close="handleClose">
      <div class="login-top" slot="title">
        <div class="logo-title justify-center items-end">
          <img src="@/assets/images/logow.png" style="width:100px;height:70px;">
          <h3>台商雜誌</h3>
        </div>
        <h4 v-if="step == 1">會員登入</h4>
        <h4 v-if="step == 2">會員註冊</h4>
        <h4 v-if="step == 3">忘記密碼</h4>
      </div>
      <div class="login-container">
        <div class="login-inp flex-col items-center" v-if="step == 1">
          <el-input placeholder="電子郵件" v-model="loginRes.email">
            <svg-icon slot="suffix" icon-class="black-envelope"></svg-icon>
          </el-input>
          <el-input placeholder="密碼" type="password" v-model="loginRes.password">
            <svg-icon slot="suffix" icon-class="Path 429"></svg-icon>
          </el-input>
          <button class="submit" @click="fnToLogin">立即登入</button>
          <span>或</span>
          <span>使用社群帳號登入</span>
          <button class="btn bg-blue items-center justify-center" @click="authToLogin('facebook')">
            <svg-icon slot="suffix" icon-class="Path 434"></svg-icon>
            Facebook 登入
          </button>
          <button class="btn bg-red3 items-center justify-center" @click="authToLogin('google')">
            <svg-icon slot="suffix" icon-class="Path 436"></svg-icon>
            Google 登入
          </button>
          <!-- <button
            class="btn bg-red3 items-center justify-center"
            @click="logout"
          >
            退出登錄
          </button> -->
          <p style="margin-top: 15px">
            還不是會員? <a href="#" @click="step = 2">立即註冊</a>
          </p>
          <p style="margin-top: 6px">
            我曾經註冊過，但我<a href="#" @click="step = 3">忘記密碼</a>
          </p>
          <a style="margin-top: 45px" href="#">隱私權條款</a>
        </div>
        <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="auto" class="demo-dynamic"
          :rules="rules">
          <div class="login-inp register-inp flex-col items-center" v-if="step == 2">
            <el-form-item prop="email" :rules="[
              { required: true, message: '請輸入電子郵箱', trigger: 'blur' },
              {
                type: 'email',
                message: '請輸入正確的電子郵箱',
                trigger: ['blur', 'change'],
              },
            ]">
              <el-input placeholder="電子郵件" v-model="dynamicValidateForm.email">
                <svg-icon slot="suffix" icon-class="black-envelope"></svg-icon>
              </el-input>
            </el-form-item>

            <el-form-item prop="code">
              <div class="code justify-between items-center">
                <el-input placeholder="驗證碼" v-model="dynamicValidateForm.code">
                  <svg-icon slot="suffix" icon-class="yzm"></svg-icon>
                </el-input>
                <button @click="getCode" :disabled="!forbiddenSend" :class="[
                  {
                    ['btn-disable']: !forbiddenSend,
                  },
                ]">
                  {{ countdown ? countdown + "後重識" : "獲取驗證碼" }}
                </button>
              </div>
            </el-form-item>
            <el-form-item prop="pass">
              <el-input type="password" placeholder="密碼" autocomplete="off" v-model="dynamicValidateForm.pass">
                <svg-icon slot="suffix" icon-class="Path 429"></svg-icon>
              </el-input>
            </el-form-item>
            <button class="submit" @click="toRegister">加入會員</button>
            <span>或</span>
            <span>使用社群帳號登入</span>
            <button class="btn bg-blue items-center justify-center" @click="authToLogin('facebook')">
              <svg-icon slot="suffix" icon-class="Path 434"></svg-icon>
              Facebook 登入
            </button>
            <button class="btn bg-red3 items-center justify-center" @click="authToLogin('google')">
              <svg-icon slot="suffix" icon-class="Path 436"></svg-icon>
              Google 登入
            </button>
            <p style="margin-top: 15px">
              我已經註冊過，
              <a class="text-red2" href="#" @click="step = 1">直接登入</a>
            </p>
            <a style="margin-top: 45px" href="#">隱私權條款</a>
          </div>
        </el-form>
        <el-form :model="dynamicValidateForm2" ref="dynamicValidateForm2" label-width="auto" class="demo-dynamic"
          :rules="rules2">
          <div class="login-inp register-inp flex-col items-center" v-if="step == 3">
            <el-form-item prop="email" :rules="[
              { required: true, message: '請輸入電子郵箱', trigger: 'blur' },
              {
                type: 'email',
                message: '請輸入正確的電子郵箱',
                trigger: ['blur', 'change'],
              },
            ]">
              <el-input placeholder="電子郵件" v-model="dynamicValidateForm2.email">
                <svg-icon slot="suffix" icon-class="black-envelope"></svg-icon>
              </el-input>
            </el-form-item>
            <el-form-item prop="code">
              <div class="code justify-between items-center">
                <el-input placeholder="驗證碼" v-model="dynamicValidateForm2.code">
                  <svg-icon slot="suffix" icon-class="yzm"></svg-icon>
                </el-input>
                <button @click="getCode2" :disabled="!forbiddenSend" :class="[
                  {
                    ['btn-disable']: !forbiddenSend,
                  },
                ]">
                  {{ countdown ? countdown + "後重識" : "獲取驗證碼" }}
                </button>
              </div>
            </el-form-item>
            <el-form-item prop="pass">
              <el-input type="password" placeholder="重設密碼" autocomplete="off" v-model="dynamicValidateForm2.pass">
                <svg-icon slot="suffix" icon-class="Path 429"></svg-icon>
              </el-input>
            </el-form-item>
            <button class="submit" @click="confirmPw">確認</button>
            <!-- <button class="submit" v-else @click="getCode">確認</button> -->

            <p style="margin-top: 15px">
              還不是會員？
              <a class="text-red2" href="#" @click="step = 2">立即註冊</a>
            </p>
            <a style="margin-top: 45px" href="#">隱私權條款</a>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { getNewsList } from "@/assets/api/news.js";
import {
  getEmailCode,
  register,
  forgetPw,
  login,
  otherLogin,
} from "@/assets/api/login.js";

export default {

  data() {
    var checkCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("驗證碼不能為空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(value) && value.length != 6) {
          callback(new Error("請輸入正確的驗證碼！"));
        } else {
          callback();
        }
      }, 1000);
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("請輸入密碼"));
      } else {
        callback();
      }
    };

    var validatePass3 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("請輸入密碼"));
      } else {

        callback();
      }
    };
    return {


      drawer: false,
      step: 1,
      email: "",
      code: "",
      dialogVisible: false,
      forbiddenSend: true, //获取验证码按钮状态
      countdown: "",
      timecountdown: false,
      dynamicValidateForm: {
        email: "",
        code: "",
        pass: "",
      },
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        code: [{ validator: checkCode, trigger: "blur" }],
      },
      // 忘记密码
      isHasCode: false, //：是否已经获取验证码
      dynamicValidateForm2: {
        email: "",
        code: "",
        pass: "",
      },
      rules2: {
        pass: [{ validator: validatePass3, trigger: "blur" }],
        code: [{ validator: checkCode, trigger: "blur" }],
      },
      loginRes: {
        email: "",
        password: "",
      },
    };
  },
  computed: {
    ...mapState(["validToken", "isDialogVisible"]),
  },
  watch: {
    isDialogVisible(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$store.state.isDialogVisible = val;
    },
  },

  methods: {
    verifiCodeSended() {
      var vm = this;
      vm.forbiddenSend = false;
      vm.step = 2;
      var time = new Date();
      var timer = setInterval(() => {
        var newTime = new Date();
        var lastTime = 60 - Math.floor((newTime - time) / 1000);
        if (lastTime <= 0) {
          clearInterval(timer);
          vm.countdown = "";
          vm.forbiddenSend = true;
          vm.timecountdown = false;
          // console.log("clearInterval",!vm.phoneNumIsValid && !vm.forbiddenSend);
        } else {
          vm.countdown = lastTime + "s";
          vm.timecountdown = true;
          vm.forbiddenSend = false;
        }
      }, 1000);
    },
    getCode() {
      // if (this.dynamicValidateForm.code !== "") {
      // this.$refs.dynamicValidateForm.validateField("email");
      // }
      this.$refs["dynamicValidateForm"].validateField(["email"], (valid) => {
        if (!valid) {
          // alert("submit!");
          console.log(valid);
          getEmailCode({
            email: this.dynamicValidateForm.email,
          }).then((res) => {
            this.verifiCodeSended();
            this.$message({
              message: "發送成功",
              type: "success",
            });
            console.log(res);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getCode2() {
      // if (this.dynamicValidateForm.code !== "") {
      // this.$refs.dynamicValidateForm.validateField("email");
      // }
      this.$refs["dynamicValidateForm2"].validateField(["email"], (valid) => {
        if (!valid) {
          // alert("submit!");
          console.log(valid);
          getEmailCode({
            email: this.dynamicValidateForm2.email,
          }).then((res) => {
            this.verifiCodeSended2();
            this.$message({
              message: "發送成功",
              type: "success",
            });
            console.log(res);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    verifiCodeSended2() {
      var vm = this;
      vm.forbiddenSend = false;
      vm.step = 3;
      var time = new Date();
      var timer = setInterval(() => {
        var newTime = new Date();
        var lastTime = 60 - Math.floor((newTime - time) / 1000);
        if (lastTime <= 0) {
          clearInterval(timer);
          vm.countdown = "";
          vm.forbiddenSend = true;
          vm.timecountdown = false;
          // console.log("clearInterval",!vm.phoneNumIsValid && !vm.forbiddenSend);
        } else {
          vm.countdown = lastTime + "s";
          vm.timecountdown = true;
          vm.forbiddenSend = false;
        }
      }, 1000);
    },
    confirmPw() {
      this.$refs["dynamicValidateForm2"].validate((valid) => {
        console.log(valid);

        if (valid) {
          // alert("submit!");
          console.log(valid);
          forgetPw({
            loginName: this.dynamicValidateForm2.email,
            password: this.dynamicValidateForm2.pass,
            code: this.dynamicValidateForm2.code,
          }).then((res) => {
            if (res.data.code != 500) {
              this.$message({
                message: "重置成功，請登錄",
                type: "success",
              });
              this.step = 1;
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            console.log(res);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    toRegister() {
      this.$refs["dynamicValidateForm"].validate((valid) => {
        if (valid) {
          // alert("submit!");
          console.log(valid);
          register({
            loginName: this.dynamicValidateForm.email,
            password: this.dynamicValidateForm.pass,
            code: this.dynamicValidateForm.code,
          }).then((res) => {
            if (res.data.code != 500) {
              this.$message({
                message: "註冊成功，請登錄",
                type: "success",
              });
              this.step = 1;
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            console.log(res);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    fnToLogin() {
      login({
        loginName: this.loginRes.email,
        password: this.loginRes.password,
      }).then((res) => {
        if (res.data.code == 500) {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        } else {
          this.$message({
            message: "登錄成功",
            type: "success",
          });
          this.dialogVisible = false;
          this.$store.state.isDialogVisible = false;
          this.$store.dispatch("checkToken");
          window.sessionStorage.setItem("token", res.data.data);
          location.reload();
        }

        console.log(res.data.data);
      });
    },
    login() {
      FB.login(function (response) {
        console.log(response);
        if (response.status === "connected") {
          // Logged into your webpage and Facebook.
        } else {
          // The person is not logged into your webpage or we are unable to tell.
        }
      });
    },
    logout() {
      FB.logout(function (response) {
        console.log(response);
        // Person is now logged out
      });
    },
    authToLogin(type) {
      otherLogin(type).then((res) => {
        console.log(res);
        window.open(res.data.data, "_self");
      });
    },
    toMyCenter() {
      this.$router.push({
        path: `/member-center`,
      });
    },


    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  .container {
    .logo-title {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .swiper-container {
    height: 20px;
    margin: 0;
  }
}

.header {
  .logo-title {
    h3 {
      padding: 3.5px 10.6px 5.2px 6.2px;
      border-radius: 3px;
      background-image: linear-gradient(116deg, #dc000c -2%, #080101 151%);
      font-family: ToppanBunkyuMidashiMincho;
      font-size: 22px;
      font-weight: 800;
      font-stretch: normal;
      font-style: normal;
      line-height: 22px;
      letter-spacing: 2.64px;
      text-align: left;
      color: #fff;
    }

    .svg-icon {
      width: 85px;
      height: 60px;
      position: relative;
      top: 13px;
    }
  }

  .icons {
    .svg-icon {
      width: 22px;
      height: 22px;
      margin-right: 16px;
    }

    .btn {
      cursor: pointer;

      .svg-icon {
        width: 60px;
        height: 60px;
        margin: 0;
      }
    }

    .btn-maz {
      width: 60px;
      height: 60px;

      .svg-icon {
        width: 30px;
        height: 30px;
      }
    }

    .menu {
      width: 60px;
      height: 60px;
    }
  }

  .el-menu {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 12px;
  }

  .el-menu.el-menu--horizontal {
    border-bottom: none;
    padding: 10px 0;
  }

  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom-color: #dc000c !important;
  }

  .el-menu--horizontal>.el-menu-item {
    font-family: ToppanBunkyuMidashiMincho;
    font-size: 16px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 1.92px;
    text-align: center;
    color: #fff;
    display: flex;
    align-items: center;
    height: auto;
    padding: 5px 0;
  }

  .el-menu::after,
  .el-menu::before {
    content: none;
  }

  .info-list {
    padding: 8px 0;

    .tag {
      margin: 0 12.1px 0 0;
    }

    span {
      padding: 0 2px 0 7px;
    }

    .tag::after {
      content: "";
      width: 0;
      height: 0;
      border: 10px solid;
      border-color: transparent transparent transparent #fff;
      display: block;
    }
  }
}

@media screen and (max-width: 768px) {
  .header {
    .logo-title {
      position: static;
      transform: translateX(0);
      padding-left: 10px;
      height: 60px;

      h3 {
        padding: 2.1px 8.6px 3.5px 3.7px;
        border-radius: 3px;
        background-image: linear-gradient(116deg, #dc000c -2%, #080101 151%);
        font-family: ToppanBunkyuMidashiMincho;
        font-size: 13px;
        font-weight: 800;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: 1.56px;
        text-align: left;
        color: #fff;
        margin-left: 2px;
        margin-top: 3px;
      }

      .svg-icon {
        width: 50px;
        height: 40px;
        position: relative;
        top: 0;
      }
    }

    .icons {
      .svg-icon {
        width: 30px;
        height: 30px;
        margin-right: 0;
      }

      .btn {
        padding: 0 10px 10px;
        position: relative;
        cursor: pointer;

        .svg-icon {
          width: 40px;
          height: 40px;
          margin: 0;
        }

        span {
          margin-top: -7px;
          white-space: nowrap;
        }
      }

      .btn-maz {
        width: 60px;
        height: 60px;

        .svg-icon {
          width: 20px;
          height: 20px;
          padding: 10px;
          box-sizing: content-box;
        }
      }
    }

    .info-list {
      padding: 8px 10px;

      .tag {
        margin: 0;
        font-family: NotoSansCJKTC;
        font-size: 12px;
        font-weight: bold;
        white-space: nowrap;
        line-height: 18px;
      }

      span {
        padding: 0 1px 0 5px;
      }

      .tag::after {
        content: "";
        width: 0;
        height: 0;
        border: 9px solid;
        border-color: transparent transparent transparent #fff;
        display: block;
      }

      .info-list-item {
        font-family: NotoSansCJKTC;
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 1px;
        height: 17px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }

  .share {
    position: fixed;
    bottom: 20px;
    width: 60%;
    left: 50%;
    transform: translateX(-50%);
  }

  .share .svg-icon {
    width: 24px;
    height: 24px;
  }
}
</style>
<!-- <style>
.login-pop .el-dialog {
  width: 95%;
  max-width: 430px;
  margin: 0 auto !important;
  top: 50%;
  transform: translateY(-50%);
}

.login-pop .el-dialog__header {
  background: #212121;
  padding: 48px 0;
}

.login-top h4 {
  font-family: NotoSansCJKTC;
  font-size: 22px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.82;
  letter-spacing: 8.8px;
  text-align: center;
  color: #fff;
  margin-top: 20px;
}

.el-dialog__headerbtn .el-dialog__close {
  color: #fff;
  font-size: 30px;
}

.el-dialog__headerbtn .el-dialog__close:hover {
  color: #fff;
}

.el-dialog__body {
  background-color: #f4f8fb;
  padding: 10px 30px;
}

.login-container span {
  font-family: NotoSansCJKTC;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #595757;
  margin-top: 3px;
}

.login-container p {
  font-family: NotoSansCJKTC;
  font-size: 12px;
  text-align: left;
  color: #acacac;
  letter-spacing: 3.6px;
}

.login-container a {
  color: #000;
  text-decoration: underline;
}

.login-inp .el-input {
  margin-top: 20px;
  padding: 15.9px 11.4px 16.1px 18px;
  background-color: #fff;
  display: flex;
  align-items: center;
}

.login-inp .el-input__inner {
  padding: 0;
  border: none;
  margin: 0;
  height: auto;
  line-height: 20px;
  font-family: NotoSansCJKTC;
  font-size: 12px;
  letter-spacing: 0.48px;
  text-align: left;
  color: #222;
}

.register-inp {
  margin-top: 20px;
}

.register-inp .el-input {
  margin-top: 0;
}

.register-inp .el-form-item {
  /* margin-top: 20px; */
  width: 100%;
}

/* .el-input__prefix,
.el-input__suffix {
  position: static;
} */
.el-input__suffix .svg-icon {
  width: 18px !important;
  height: 18px !important;
  display: block;
}

.submit {
  cursor: pointer;
  width: 100%;
  margin: 28px 0 9.2px;
  padding: 14px 0;
  background-color: #222;
  font-family: NotoSansCJKTC;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1.6px;
  text-align: center;
  color: #fff;
  border: none;
}

.login-inp .btn {
  cursor: pointer;
  width: 100%;
  border: none;
  font-family: NotoSansCJKTC;
  font-size: 16px;
  padding: 14px 0;
  margin-top: 10px;
  text-align: left;
  color: #fff;
}

.login-inp .btn .svg-icon {
  width: 30px;
  height: 24px;
  margin-right: 12px;
}

.el-drawer {
  width: 100% !important;
  background-color: #dc000c;
}

.el-drawer__wrapper {
  top: 92px;
}

.el-drawer__header {
  display: none;
}

.el-drawer .el-menu {
  background-color: #dc000c;
  border-right: none;
}

.el-drawer .el-menu-item {
  padding: 15px 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.35);
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: ToppanBunkyuMidashiMincho;
  font-size: 18px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 2.16px;
  line-height: 18px;
  text-align: center;
  color: #fff;
  height: auto;
}

.el-drawer .el-menu-item.is-active {
  background-color: #dc000c !important;
}

.code {
  width: 100%;
}

.code .el-input {
  margin-top: 0;
}

.code button {
  width: 98px;
  cursor: pointer;
  background: #222;
  border: none;
  color: #fff;
  height: 100%;
  font-family: NotoSansCJKTC;
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
  padding: 16px;
}

.code button.btn-disable {
  background: rgba(34, 34, 34, 0.28);
}

.login-container .el-input__suffix {
  margin-top: 0;
}

@media screen and (max-width: 768px) {
  .login-pop .el-dialog__header {
    padding: 20px 0 8px;
  }

  .login-top h4 {
    margin-top: 0px;
    line-height: 33px;
  }

  .el-dialog__header .login-top .logo-title .svg-icon {
    width: 80px;
    height: 60px;
  }

  .el-dialog__header .login-top .logo-title h3 {
    font-family: ToppanBunkyuMidashiMincho;
    font-size: 22px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 2.64px;
    text-align: left;
    color: #fff;
    padding: 3.5px 10.6px 5.2px 6.2px;
    border-radius: 3px;
    background-image: linear-gradient(116deg, #dc000c -2%, #080101 151%);
    position: relative;
    top: -4px;
  }

  .el-dialog__headerbtn {
    top: 10px;
    right: 12px;
  }

  .el-dialog__headerbtn .el-dialog__close {
    font-size: 24px;
  }
}
</style> -->



// WEBPACK FOOTER //
// src/views/expert-details/login-button.vue